export default __webpack_public_path__ + "static/media/MarcaDagua.08ed89d7.png";